import LinkWithArrow from "@components/ui/general/LinkWithArrow";
import { LinkWithArrowProps } from "@types";
import React from "react";

export default function SocialLink({ ...props }: LinkWithArrowProps) {
  return <LinkWithArrow className="nav-menu__social-link" {...props} />;
}
